var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 67,
    height: 36,
    viewBox: "0 0 67 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -19.683,
    y1: -1.955,
    x2: -0.722,
    y2: 0.323,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ffa608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -10.554,
    y1: -1.935,
    x2: 0.115,
    y2: 0.377,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -6.876,
    y1: -1.828,
    x2: 0.448,
    y2: 0.466,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.935,
    y1: -1.798,
    x2: 0.624,
    y2: 0.514,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -3.765,
    y1: -1.734,
    x2: 0.728,
    y2: 0.581,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -2.958,
    y1: -1.666,
    x2: 0.801,
    y2: 0.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -2.385,
    y1: -1.577,
    x2: 0.854,
    y2: 0.709,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -1.946,
    y1: -1.508,
    x2: 0.893,
    y2: 0.786,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -1.606,
    y1: -1.421,
    x2: 0.923,
    y2: 0.847,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -1.335,
    y1: -1.392,
    x2: 0.948,
    y2: 0.923,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -1.109,
    y1: -1.296,
    x2: 0.966,
    y2: 0.983,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -0.921,
    y1: -1.22,
    x2: 0.985,
    y2: 1.048,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: -0.766,
    y1: -1.164,
    x2: 1,
    y2: 1.119,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -0.627,
    y1: -1.066,
    x2: 1.012,
    y2: 1.174,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: -0.51,
    y1: -0.994,
    x2: 1.022,
    y2: 1.236,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: -0.406,
    y1: -0.984,
    x2: 1.031,
    y2: 1.332,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: -0.396,
    y1: -0.951,
    x2: 1.045,
    y2: 1.321,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -0.46,
    y1: -1.002,
    x2: 1.057,
    y2: 1.314,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -0.532,
    y1: -1.027,
    x2: 1.074,
    y2: 1.288,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -0.616,
    y1: -1.02,
    x2: 1.092,
    y2: 1.252,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: -0.707,
    y1: -1.07,
    x2: 1.112,
    y2: 1.235,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: -0.818,
    y1: -1.088,
    x2: 1.137,
    y2: 1.205,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.953,
    y1: -1.164,
    x2: 1.164,
    y2: 1.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: -1.108,
    y1: -1.137,
    x2: 1.197,
    y2: 1.153,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: -1.277,
    y1: -1.159,
    x2: 1.235,
    y2: 1.127,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -1.5,
    y1: -1.194,
    x2: 1.281,
    y2: 1.103,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: -1.766,
    y1: -1.236,
    x2: 1.335,
    y2: 1.071,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: -2.13,
    y1: -1.258,
    x2: 1.417,
    y2: 1.058,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: -2.549,
    y1: -1.268,
    x2: 1.507,
    y2: 1.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: -3.171,
    y1: -1.262,
    x2: 1.637,
    y2: 0.989,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: -4.052,
    y1: -1.374,
    x2: 1.822,
    y2: 0.987,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: -5.386,
    y1: -1.34,
    x2: 2.11,
    y2: 0.947,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -7.911,
    y1: -1.402,
    x2: 2.652,
    y2: 0.928,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: -13.255,
    y1: -1.429,
    x2: 3.771,
    y2: 0.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: -13.264,
    y1: -0.754,
    x2: 3.758,
    y2: 0.757,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    y1: 0.752,
    x2: 0.314,
    y2: 0.416,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#e555ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e242ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 0.703,
    y1: 0.742,
    x2: -0.266,
    y2: -0.149,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7c74ad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8471b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#b064d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#c260e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 0.415,
    y1: 1.04,
    x2: 0.572,
    y2: 0.676,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bd4ce2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf31e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 0.597,
    y1: 0.581,
    x2: 0.088,
    y2: 0.224,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#b35bd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ea73ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: -1.946,
    y1: 3.674,
    x2: 1.937,
    y2: -1.125,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#ff7416"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc002"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -2.456,
    y1: 4.242,
    x2: 2.24,
    y2: -1.538,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: -2.651,
    y1: 4.692,
    x2: 2.351,
    y2: -1.83,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: -2.718,
    y1: 4.821,
    x2: 2.4,
    y2: -1.883,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: -2.784,
    y1: 4.909,
    x2: 2.438,
    y2: -1.956,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -2.824,
    y1: 4.978,
    x2: 2.461,
    y2: -1.997,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: -2.852,
    y1: 5.032,
    x2: 2.478,
    y2: -2.033,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: -2.878,
    y1: 5.107,
    x2: 2.493,
    y2: -2.08,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: -2.893,
    y1: 5.12,
    x2: 2.502,
    y2: -2.091,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: -2.896,
    y1: 5.108,
    x2: 2.504,
    y2: -2.08,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: -2.913,
    y1: 5.134,
    x2: 2.515,
    y2: -2.101,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -2.922,
    y1: 5.138,
    x2: 2.519,
    y2: -2.104,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -2.934,
    y1: 5.148,
    x2: 2.526,
    y2: -2.106,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -2.948,
    y1: 5.16,
    x2: 2.535,
    y2: -2.111,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -2.956,
    y1: 5.172,
    x2: 2.539,
    y2: -2.121,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -2.962,
    y1: 5.171,
    x2: 2.543,
    y2: -2.119,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -2.968,
    y1: 5.178,
    x2: 2.546,
    y2: -2.123,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -2.974,
    y1: 5.188,
    x2: 2.55,
    y2: -2.126,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: -2.974,
    y1: 5.2,
    x2: 2.549,
    y2: -2.137,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: -2.977,
    y1: 5.204,
    x2: 2.551,
    y2: -2.139,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: -2.979,
    y1: 5.217,
    x2: 2.553,
    y2: -2.144,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -2.982,
    y1: 5.215,
    x2: 2.554,
    y2: -2.144,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: -2.983,
    y1: 5.241,
    x2: 2.555,
    y2: -2.159,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: -2.983,
    y1: 5.242,
    x2: 2.555,
    y2: -2.161,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: -2.986,
    y1: 5.255,
    x2: 2.557,
    y2: -2.166,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -2.983,
    y1: 5.256,
    x2: 2.555,
    y2: -2.165,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: -2.984,
    y1: 5.26,
    x2: 2.556,
    y2: -2.17,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: -2.986,
    y1: 5.259,
    x2: 2.557,
    y2: -2.168,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -2.998,
    y1: 5.253,
    x2: 2.563,
    y2: -2.166,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: -3.01,
    y1: 5.21,
    x2: 2.567,
    y2: -2.146,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: -3.003,
    y1: 5.175,
    x2: 2.561,
    y2: -2.121,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: -3.007,
    y1: 5.102,
    x2: 2.556,
    y2: -2.082,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -3.067,
    y1: 4.844,
    x2: 2.58,
    y2: -1.935,
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: -3.012,
    y1: 4.048,
    x2: 2.499,
    y2: -1.379,
    xlinkHref: "#linear-gradient-40"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203",
    transform: "translate(-497 205)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1235",
    "data-name": "Group 1235"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_756",
    "data-name": "Path 756",
    d: "M97.486,49.578l-.04.245h-.352l.2-.245Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_757",
    "data-name": "Path 757",
    d: "M96.87,50.1l-.178.241h.648l.047-.241Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_758",
    "data-name": "Path 758",
    d: "M96.461,50.617l-.182.243h.966l.046-.233Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_759",
    "data-name": "Path 759",
    d: "M96.04,51.143l-.18.241h1.3l.038-.241Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_760",
    "data-name": "Path 760",
    d: "M95.631,51.66l-.18.24h1.6l.047-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M95.215,52.184l-.182.24h1.931l.04-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M94.8,52.7l-.187.24,2.25,0L96.9,52.7Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M94.38,53.221l-.18.243h2.567l.042-.243Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M93.973,53.734l-.186.245h2.88l.049-.245Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M93.557,54.26l-.183.24h3.2l.044-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M93.148,54.773l-.187.244h3.52l.05-.244Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M92.723,55.3l-.183.245h3.84l.047-.245Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M92.321,55.814l-.189.244h4.143l.052-.244Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M91.9,56.338l-.189.248h4.47l.049-.247Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M91.492,56.848l-.187.25h4.784l.052-.25Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M91.076,57.371l-.183.24H96l.051-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M90.8,57.895l.1.245h5l.042-.245Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M90.968,58.418l.084.24H95.8l.047-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M91.137,58.934l.093.24h4.484l.036-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M91.317,59.455l.073.245h4.215l.05-.243Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M91.485,59.973l.091.241h3.937l.044-.242Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M91.668,60.5l.1.243,3.646,0,.043-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M91.863,61.018l.1.235h3.358l.045-.235Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M92.051,61.535l.087.243h3.087l.042-.243Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M92.218,62.047l.092.243,2.813,0,.045-.242Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M92.409,62.574l.1.242H95.03l.043-.242Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_782",
    "data-name": "Path 782",
    d: "M92.594,63.092l.084.237,2.259,0,.046-.241Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_783",
    "data-name": "Path 783",
    d: "M92.785,63.611l.084.24h1.969l.035-.24Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_784",
    "data-name": "Path 784",
    d: "M92.954,64.127l.1.243H94.74l.04-.243Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_785",
    "data-name": "Path 785",
    d: "M93.145,64.662l.1.235h1.4l.047-.247Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_786",
    "data-name": "Path 786",
    d: "M93.331,65.172l.081.236H94.55l.042-.236Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M93.5,65.693l.089.243h.857l.042-.243Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M93.691,66.211l.093.239h.572l.036-.239Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M93.873,66.732l.1.239h.293l.047-.239Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M94.174,67.213h-.153l.055.129h.078Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-35)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_791",
    "data-name": "Path 791",
    d: "M94.149,67.346l9.323-15.468L106.412,47l-8.949,2.526Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_792",
    "data-name": "Path 792",
    d: "M106.412,47l-2.94,4.879L119,61.09Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-37)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1236",
    "data-name": "Group 1236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_793",
    "data-name": "Path 793",
    d: "M80.953,70.455l6.454,8.51L70.928,83Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_794",
    "data-name": "Path 794",
    d: "M52,70.275,70.94,83l3.939-4.928Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_795",
    "data-name": "Path 795",
    d: "M87.251,78.773l.052.061-.082.045-.079-.037Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_796",
    "data-name": "Path 796",
    d: "M87.059,78.518l.054.07-.234.143-.089-.046Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_797",
    "data-name": "Path 797",
    d: "M86.924,78.336l-.39.24-.094-.041.429-.26Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_798",
    "data-name": "Path 798",
    d: "M86.682,78.024l.055.07-.55.331-.1-.042.595-.36Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-43)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M85.743,78.232l.087.044.72-.433-.057-.064Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-44)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_800",
    "data-name": "Path 800",
    d: "M85.394,78.078l.086.043.882-.529-.054-.064Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_801",
    "data-name": "Path 801",
    d: "M85.047,77.925l.082.042,1.043-.624-.054-.062Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_802",
    "data-name": "Path 802",
    d: "M84.7,77.774l.081.037,1.2-.72-.057-.057Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_803",
    "data-name": "Path 803",
    d: "M84.348,77.625l.08.039,1.366-.818-.052-.057Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-48)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_804",
    "data-name": "Path 804",
    d: "M84,77.47l.075.042,1.532-.911-.055-.066Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M83.649,77.316l.08.043,1.687-1.009-.047-.064Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M83.3,77.166l.078.043,1.85-1.111-.05-.061Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M82.962,77.017l.069.038,2.009-1.2-.052-.064Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_808",
    "data-name": "Path 808",
    d: "M82.615,76.87l.063.033,2.173-1.3-.05-.064Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_809",
    "data-name": "Path 809",
    d: "M82.276,76.719l.05.031,2.341-1.4-.051-.059Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_810",
    "data-name": "Path 810",
    d: "M81.929,76.57l.05.029,2.5-1.5-.058-.062Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_811",
    "data-name": "Path 811",
    d: "M81.585,76.419l.044.028,2.661-1.592-.057-.061Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_812",
    "data-name": "Path 812",
    d: "M81.239,76.269l.038.024L84.1,74.611l-.049-.066Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-57)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M80.893,76.115l.038.025,2.982-1.78-.053-.06Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M80.549,75.965l.027.024,3.151-1.876-.05-.06Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M80.2,75.813l.027.019,3.314-1.97-.051-.061Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M79.853,75.666l.019.018,3.476-2.065-.053-.063Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_817",
    "data-name": "Path 817",
    d: "M79.5,75.513l.016.015,3.646-2.16-.051-.057Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_818",
    "data-name": "Path 818",
    d: "M79.158,75.357l.016.016,3.8-2.255-.055-.058Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_819",
    "data-name": "Path 819",
    d: "M78.806,75.21l.013.009,3.969-2.344-.046-.062Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_820",
    "data-name": "Path 820",
    d: "M78.457,75.058l.012.009,4.136-2.439-.058-.065Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_821",
    "data-name": "Path 821",
    d: "M78.108,74.905l.008.011,4.3-2.537-.055-.062Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_822",
    "data-name": "Path 822",
    d: "M77.97,74.63l.008.008,4.251-2.51-.051-.061Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_823",
    "data-name": "Path 823",
    d: "M78.463,73.988V73.97l3.531-2.146.038.054Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_824",
    "data-name": "Path 824",
    d: "M78.948,73.352l.058-.085,2.8-1.691.034.05Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_825",
    "data-name": "Path 825",
    d: "M79.42,72.707l.069-.1,2.132-1.285.041.056Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    d: "M79.9,72.066l.109-.145,1.416-.84.047.051Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    d: "M80.395,71.421l.011-.016.087-.134.751-.446.038.06Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    d: "M80.876,70.759l.094-.126.084-.057.044.066Z",
    transform: "translate(445 -252)",
    fill: "url(#linear-gradient-73)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1232",
    "data-name": "Group 1232"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    d: "M54.775,69.549l1.055-2.123A6.913,6.913,0,0,0,59.9,68.783c1.349,0,2.422-.609,2.422-1.566,0-.627-.536-1.01-2.145-1.479-2.3-.609-3.789-1.6-3.789-3.359,0-2.419,2.111-4.072,5.225-4.072a10.323,10.323,0,0,1,3.685.679L65,61.265a6.931,6.931,0,0,0-3.27-.766c-1.367,0-2.509.679-2.509,1.514,0,.627.5.975,2.093,1.427,2.612.661,3.823,1.671,3.823,3.289,0,2.663-2.37,4.246-5.277,4.246a9.581,9.581,0,0,1-5.086-1.427Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    d: "M67.731,67.243l.647-4.711H66.3l.235-1.636,4.957-3.508h.666l-.392,2.818h3.39l-.333,2.346h-3.39l-.529,3.863c-.2,1.281.314,1.951,1.469,1.951a3.853,3.853,0,0,0,1.548-.335l-.294,2.7a9.426,9.426,0,0,1-1.94.276c-2.685,0-4.35-1.045-3.958-3.765Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    d: "M76.49,60.208h.431L78.371,62h.078a4.692,4.692,0,0,1,3.919-2.07,4.579,4.579,0,0,1,1.567.256l-.392,2.641a2.212,2.212,0,0,0-1.391-.394,3.518,3.518,0,0,0-3.39,3.272l-.686,5.026H75.02l1.469-10.525Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    d: "M85.19,60.207h3.076L86.8,70.732H83.72Zm.255-2.779a1.9,1.9,0,0,1,1.9-1.793,1.386,1.386,0,0,1,1.489,1.38,1.888,1.888,0,0,1-1.881,1.833A1.422,1.422,0,0,1,85.444,57.428Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    d: "M90.774,55.379H93.83l-1.254,8.929h.137l4.056-4.1h3.507l-4.33,4.376,3.331,6.149H95.75l-2.195-4.1h-.137l-1.352,1.32-.372,2.779H88.637l2.136-15.354Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    d: "M101.688,60.207h3.076l-1.469,10.525h-3.077Zm.254-2.779a1.9,1.9,0,0,1,1.9-1.793,1.386,1.386,0,0,1,1.489,1.38,1.888,1.888,0,0,1-1.881,1.833A1.422,1.422,0,0,1,101.942,57.428Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    d: "M105.43,66.317c0-2.621,2.058-6.386,6.212-6.386a4.385,4.385,0,0,1,4.6,4.553,8.663,8.663,0,0,1-.313,2.03h-7.818c.019,1.419,1.018,2.227,2.9,2.227a6.26,6.26,0,0,0,3.468-1.025l.157,2.227a8.083,8.083,0,0,1-4.115,1.045c-3.507,0-5.094-2.148-5.094-4.671Zm8.21-1.458a2.207,2.207,0,0,0-2.214-2.641,3.273,3.273,0,0,0-3.154,2.681l5.369-.039Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    d: "M80.471,59.8l1.164.2,1.1.061,1.773-.573Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    d: "M83.469,57.98l1.448.245.914-.4Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    d: "M81.239,65.172c.062.053.362.236.362.236l1.356-.17Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    d: "M81.721,65.977l1.949.126s1.046-.537,1.029-.537S81.721,65.977,81.721,65.977Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    d: "M98.932,64.127v.15l2.348.093Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    d: "M99.311,57.371c.014.062.149.921.149.921l2.924-.275-3.073-.646Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "M107.309,60.5l.609.243,1.908-.243Z",
    transform: "translate(445 -252)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.55781308729f613667ddaf0cd7988452.svg";
export { ForwardRef as ReactComponent };